"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = textSaga;
exports.discoverExternalOcr = discoverExternalOcr;
exports.fetchAndProcessOcr = fetchAndProcessOcr;
exports.fetchAnnotationResource = fetchAnnotationResource;
exports.fetchColors = fetchColors;
exports.fetchExternalAnnotationResources = fetchExternalAnnotationResources;
exports.fetchOcrMarkup = fetchOcrMarkup;
exports.injectTranslations = injectTranslations;
exports.loadImageData = loadImageData;
exports.onConfigChange = onConfigChange;
exports.processTextsFromAnnotations = processTextsFromAnnotations;
var _uniq = _interopRequireDefault(require("lodash/uniq"));
var _effects = require("redux-saga/effects");
var _isomorphicUnfetch = _interopRequireDefault(require("isomorphic-unfetch"));
var _actionTypes = _interopRequireDefault(require("mirador/dist/es/src/state/actions/action-types"));
var _actions = require("mirador/dist/es/src/state/actions");
var _selectors = require("mirador/dist/es/src/state/selectors");
var _MiradorCanvas = _interopRequireDefault(require("mirador/dist/es/src/lib/MiradorCanvas"));
var _actions2 = require("./actions");
var _selectors2 = require("./selectors");
var _locales = _interopRequireDefault(require("../locales"));
var _ocrFormats = require("../lib/ocrFormats");
var _color = require("../lib/color");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(injectTranslations),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(textSaga);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var charFragmentPattern = /^(.+)#char=(\d+),(\d+)$/;

/** Check if an annotation has external resources that need to be loaded */
function hasExternalResource(anno) {
  var _anno$resource, _anno$body;
  return ((_anno$resource = anno.resource) === null || _anno$resource === void 0 ? void 0 : _anno$resource.chars) === undefined && ((_anno$body = anno.body) === null || _anno$body === void 0 ? void 0 : _anno$body.value) === undefined && Object.keys(anno.resource).length === 1 && anno.resource['@id'] !== undefined;
}

/** Checks if a given resource points to an ALTO OCR document */
var isAlto = function isAlto(resource) {
  return resource && (resource.format === 'application/xml+alto' || resource.format === 'application/alto+xml' || resource.profile && resource.profile.startsWith('http://www.loc.gov/standards/alto/'));
};

/** Checks if a given resource points to an hOCR document */
var isHocr = function isHocr(resource) {
  return resource && (resource.format === 'text/vnd.hocr+html' || resource.profile && (resource.profile === 'https://github.com/kba/hocr-spec/blob/master/hocr-spec.md' || resource.profile.startsWith('http://kba.cloud/hocr-spec/') || resource.profile.startsWith('http://kba.github.io/hocr-spec/')));
};

/** Wrapper around fetch() that returns the content as text */
function fetchOcrMarkup(_x) {
  return _fetchOcrMarkup.apply(this, arguments);
}
/** Saga for discovering external OCR on visible canvases and requesting it if not yet loaded */
function _fetchOcrMarkup() {
  _fetchOcrMarkup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(url) {
    var resp;
    return _regeneratorRuntime().wrap(function _callee7$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _isomorphicUnfetch["default"])(url);
        case 2:
          resp = _context9.sent;
          return _context9.abrupt("return", resp.text());
        case 4:
        case "end":
          return _context9.stop();
      }
    }, _callee7);
  }));
  return _fetchOcrMarkup.apply(this, arguments);
}
function discoverExternalOcr(_ref) {
  var visibleCanvasIds = _ref.visibleCanvases,
    windowId = _ref.windowId;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$select$textOve;
    var _ref2, enabled, selectable, visible, canvases, visibleCanvases, texts, _iterator, _step, canvas, _canvas$__jsonld, width, height, seeAlso, _texts$canvas$id, ocrSource, alreadyHasText, miradorCanvas, image, infoId;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.getWindowConfig, {
            windowId: windowId
          });
        case 2:
          _context.t1 = _yield$select$textOve = _context.sent.textOverlay;
          _context.t0 = _context.t1 !== null;
          if (!_context.t0) {
            _context.next = 6;
            break;
          }
          _context.t0 = _yield$select$textOve !== void 0;
        case 6:
          if (!_context.t0) {
            _context.next = 10;
            break;
          }
          _context.t2 = _yield$select$textOve;
          _context.next = 11;
          break;
        case 10:
          _context.t2 = {
            enabled: false
          };
        case 11:
          _ref2 = _context.t2;
          enabled = _ref2.enabled;
          selectable = _ref2.selectable;
          visible = _ref2.visible;
          if (enabled) {
            _context.next = 17;
            break;
          }
          return _context.abrupt("return");
        case 17:
          _context.next = 19;
          return (0, _effects.select)(_selectors.getCanvases, {
            windowId: windowId
          });
        case 19:
          canvases = _context.sent;
          visibleCanvases = (canvases || []).filter(function (c) {
            return visibleCanvasIds.includes(c.id);
          });
          _context.next = 23;
          return (0, _effects.select)(_selectors2.getTexts);
        case 23:
          texts = _context.sent;
          _iterator = _createForOfIteratorHelperLoose(visibleCanvases);
        case 25:
          if ((_step = _iterator()).done) {
            _context.next = 50;
            break;
          }
          canvas = _step.value;
          _canvas$__jsonld = canvas.__jsonld, width = _canvas$__jsonld.width, height = _canvas$__jsonld.height;
          seeAlso = (Array.isArray(canvas.__jsonld.seeAlso) ? canvas.__jsonld.seeAlso : [canvas.__jsonld.seeAlso]).filter(function (res) {
            return isAlto(res) || isHocr(res);
          })[0];
          if (!(seeAlso !== undefined)) {
            _context.next = 48;
            break;
          }
          ocrSource = seeAlso['@id'] ? seeAlso['@id'] : seeAlso['id'];
          alreadyHasText = ((_texts$canvas$id = texts[canvas.id]) === null || _texts$canvas$id === void 0 ? void 0 : _texts$canvas$id.source) === ocrSource;
          if (!alreadyHasText) {
            _context.next = 34;
            break;
          }
          return _context.abrupt("continue", 48);
        case 34:
          if (!(selectable || visible)) {
            _context.next = 39;
            break;
          }
          _context.next = 37;
          return (0, _effects.put)((0, _actions2.requestText)(canvas.id, ocrSource, {
            height: height,
            width: width
          }));
        case 37:
          _context.next = 41;
          break;
        case 39:
          _context.next = 41;
          return (0, _effects.put)((0, _actions2.discoveredText)(canvas.id, ocrSource));
        case 41:
          // Get the IIIF Image Service from the canvas to determine text/background colors
          // NOTE: We don't do this in the `fetchColors` saga, since it's kind of a pain to get
          // a canvas object from an id, and we have one already here, so it's just simpler.
          miradorCanvas = new _MiradorCanvas["default"](canvas);
          image = miradorCanvas.iiifImageResources[0];
          infoId = image === null || image === void 0 ? void 0 : image.getServices()[0].id;
          if (infoId) {
            _context.next = 46;
            break;
          }
          return _context.abrupt("return");
        case 46:
          _context.next = 48;
          return (0, _effects.put)((0, _actions2.requestColors)(canvas.id, infoId));
        case 48:
          _context.next = 25;
          break;
        case 50:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })();
}

/** Saga for fetching OCR and parsing it */
function fetchAndProcessOcr(_ref3) {
  var targetId = _ref3.targetId,
    textUri = _ref3.textUri,
    canvasSize = _ref3.canvasSize;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var text, parsedText;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(fetchOcrMarkup, textUri);
        case 3:
          text = _context2.sent;
          _context2.next = 6;
          return (0, _effects.call)(_ocrFormats.parseOcr, text, canvasSize);
        case 6:
          parsedText = _context2.sent;
          _context2.next = 9;
          return (0, _effects.put)((0, _actions2.receiveText)(targetId, textUri, 'ocr', parsedText));
        case 9:
          _context2.next = 15;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 15;
          return (0, _effects.put)((0, _actions2.receiveTextFailure)(targetId, textUri, _context2.t0));
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  })();
}

/** Fetch external annotation resource JSON */
function fetchAnnotationResource(_x2) {
  return _fetchAnnotationResource.apply(this, arguments);
}
/** Saga for fetching external annotation resources */
function _fetchAnnotationResource() {
  _fetchAnnotationResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(url) {
    var resp;
    return _regeneratorRuntime().wrap(function _callee8$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _isomorphicUnfetch["default"])(url);
        case 2:
          resp = _context10.sent;
          return _context10.abrupt("return", resp.json());
        case 4:
        case "end":
          return _context10.stop();
      }
    }, _callee8);
  }));
  return _fetchAnnotationResource.apply(this, arguments);
}
function fetchExternalAnnotationResources(_ref4) {
  var targetId = _ref4.targetId,
    annotationId = _ref4.annotationId,
    annotationJson = _ref4.annotationJson;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var resourceUris, contents, contentMap, completedAnnos;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (annotationJson.resources.some(hasExternalResource)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          resourceUris = (0, _uniq["default"])(annotationJson.resources.map(function (anno) {
            return anno.resource['@id'].split('#')[0];
          }));
          _context3.next = 5;
          return (0, _effects.all)(resourceUris.map(function (uri) {
            return (0, _effects.call)(fetchAnnotationResource, uri);
          }));
        case 5:
          contents = _context3.sent;
          contentMap = Object.fromEntries(contents.map(function (c) {
            var _c$id;
            return [(_c$id = c.id) !== null && _c$id !== void 0 ? _c$id : c['@id'], c];
          }));
          completedAnnos = annotationJson.resources.map(function (anno) {
            if (!hasExternalResource(anno)) {
              return anno;
            }
            var match = anno.resource['@id'].match(charFragmentPattern);
            if (!match) {
              var _contentMap$anno$reso;
              return _extends({}, anno, {
                resource: (_contentMap$anno$reso = contentMap[anno.resource['@id']]) !== null && _contentMap$anno$reso !== void 0 ? _contentMap$anno$reso : anno.resource
              });
            }
            var wholeResource = contentMap[match[1]];
            var startIdx = Number.parseInt(match[2], 10);
            var endIdx = Number.parseInt(match[3], 10);
            var partialContent = wholeResource.value.substring(startIdx, endIdx);
            return _extends({}, anno, {
              resource: _extends({}, anno.resource, {
                value: partialContent
              })
            });
          });
          _context3.next = 10;
          return (0, _effects.put)((0, _actions.receiveAnnotation)(targetId, annotationId, _extends({}, annotationJson, {
            resources: completedAnnos
          })));
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })();
}

/** Saga for processing texts from IIIF annotations */
function processTextsFromAnnotations(_ref5) {
  var targetId = _ref5.targetId,
    annotationId = _ref5.annotationId,
    annotationJson = _ref5.annotationJson;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var contentAsTextAnnos, parsed;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          // Check if the annotation contains "content as text" resources that
          // we can extract text with coordinates from
          contentAsTextAnnos = annotationJson.resources.filter(function (anno) {
            var _anno$resource$Type;
            return anno.motivation === 'supplementing' ||
            // IIIF 3.0
            ((_anno$resource$Type = anno.resource['@type']) === null || _anno$resource$Type === void 0 ? void 0 : _anno$resource$Type.toLowerCase()) === 'cnt:contentastext' ||
            // IIIF 2.0
            ['Line', 'Word'].indexOf(anno.dcType) >= 0;
          } // Europeana IIIF 2.0
          );
          if (!(contentAsTextAnnos.length > 0)) {
            _context4.next = 7;
            break;
          }
          _context4.next = 4;
          return (0, _effects.call)(_ocrFormats.parseIiifAnnotations, contentAsTextAnnos);
        case 4:
          parsed = _context4.sent;
          _context4.next = 7;
          return (0, _effects.put)((0, _actions2.receiveText)(targetId, annotationId, 'annos', parsed));
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })();
}

/** Saga for requesting texts when display or selection is newly enabled */
function onConfigChange(_ref6) {
  var payload = _ref6.payload,
    windowId = _ref6.id;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _payload$textOverlay;
    var _ref7, enabled, selectable, visible, texts, needFetching, needsDiscovery, visibleCanvases, canvasIds;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _ref7 = (_payload$textOverlay = payload.textOverlay) !== null && _payload$textOverlay !== void 0 ? _payload$textOverlay : {}, enabled = _ref7.enabled, selectable = _ref7.selectable, visible = _ref7.visible;
          if (!(!enabled || !selectable && !visible)) {
            _context5.next = 3;
            break;
          }
          return _context5.abrupt("return");
        case 3:
          _context5.next = 5;
          return (0, _effects.select)(_selectors2.getTextsForVisibleCanvases, {
            windowId: windowId
          });
        case 5:
          texts = _context5.sent;
          // Check if any of the texts need fetching
          needFetching = texts.filter(function (_ref8) {
            var sourceType = _ref8.sourceType,
              text = _ref8.text;
            return sourceType === 'ocr' && text === undefined;
          }); // Check if we need to discover external OCR
          needsDiscovery = texts.length === 0 || texts.filter(function (_temp) {
            var _ref9 = _temp === void 0 ? {} : _temp,
              sourceType = _ref9.sourceType;
            return sourceType === 'annos';
          }).length > 0;
          if (!(needFetching.length === 0 && !needsDiscovery)) {
            _context5.next = 10;
            break;
          }
          return _context5.abrupt("return");
        case 10:
          _context5.next = 12;
          return (0, _effects.select)(_selectors.getVisibleCanvases, {
            windowId: windowId
          });
        case 12:
          visibleCanvases = _context5.sent;
          _context5.next = 15;
          return (0, _effects.all)(needFetching.map(function (_ref10) {
            var canvasId = _ref10.canvasId,
              source = _ref10.source;
            var _visibleCanvases$find = visibleCanvases.find(function (c) {
                return c.id === canvasId;
              }).__jsonld,
              width = _visibleCanvases$find.width,
              height = _visibleCanvases$find.height;
            return (0, _effects.put)((0, _actions2.requestText)(canvasId, source, {
              height: height,
              width: width
            }));
          }));
        case 15:
          if (!needsDiscovery) {
            _context5.next = 19;
            break;
          }
          canvasIds = visibleCanvases.map(function (c) {
            return c.id;
          });
          _context5.next = 19;
          return (0, _effects.call)(discoverExternalOcr, {
            visibleCanvases: canvasIds,
            windowId: windowId
          });
        case 19:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  })();
}

/** Inject translation keys for this plugin into thte config */
function injectTranslations() {
  return _regeneratorRuntime().wrap(function injectTranslations$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return (0, _effects.put)((0, _actions.updateConfig)({
          translations: _locales["default"]
        }));
      case 2:
      case "end":
        return _context6.stop();
    }
  }, _marked);
}

/** Load image data for image */
function loadImageData(_x3) {
  return _loadImageData.apply(this, arguments);
}
/** Try to determine text and background color for the target */
function _loadImageData() {
  _loadImageData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(imgUrl) {
    return _regeneratorRuntime().wrap(function _callee9$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", new Promise(function (resolve, reject) {
            var img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
              var canvas = document.createElement('canvas');
              var ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0);
              resolve(ctx.getImageData(0, 0, img.width, img.height).data);
            };
            img.onerror = reject;
            img.src = imgUrl;
          }));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee9);
  }));
  return _loadImageData.apply(this, arguments);
}
function fetchColors(_ref11) {
  var targetId = _ref11.targetId,
    infoId = _ref11.infoId;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var infoResp, serviceId, _infoSuccess$infoJson, _yield$race, infoSuccess, infoFailure, imgUrl, imgData, _yield$call, textColor, bgColor;
    return _regeneratorRuntime().wrap(function _callee6$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(_selectors.selectInfoResponse, {
            infoId: infoId
          });
        case 2:
          infoResp = _context7.sent;
          serviceId = infoResp === null || infoResp === void 0 ? void 0 : infoResp.id;
          if (serviceId) {
            _context7.next = 13;
            break;
          }
          _context7.next = 7;
          return (0, _effects.race)({
            success: (0, _effects.take)(function (a) {
              return a.type === _actionTypes["default"].RECEIVE_INFO_RESPONSE && a.infoId === infoId;
            }),
            failure: (0, _effects.take)(function (a) {
              return a.type === _actionTypes["default"].RECEIVE_INFO_RESPONSE_FAILURE && a.infoId === infoId;
            })
          });
        case 7:
          _yield$race = _context7.sent;
          infoSuccess = _yield$race.success;
          infoFailure = _yield$race.failure;
          if (!infoFailure) {
            _context7.next = 12;
            break;
          }
          return _context7.abrupt("return");
        case 12:
          serviceId = (_infoSuccess$infoJson = infoSuccess.infoJson) === null || _infoSuccess$infoJson === void 0 ? void 0 : _infoSuccess$infoJson['@id'];
        case 13:
          _context7.prev = 13;
          // FIXME: This assumes a Level 2 endpoint, we should probably use one of the sizes listed
          //        explicitely in the info response instead.
          imgUrl = serviceId + "/full/200,/0/default.jpg";
          _context7.next = 17;
          return (0, _effects.call)(loadImageData, imgUrl);
        case 17:
          imgData = _context7.sent;
          _context7.next = 20;
          return (0, _effects.call)(_color.getPageColors, imgData);
        case 20:
          _yield$call = _context7.sent;
          textColor = _yield$call.textColor;
          bgColor = _yield$call.bgColor;
          _context7.next = 25;
          return (0, _effects.put)((0, _actions2.receiveColors)(targetId, textColor, bgColor));
        case 25:
          _context7.next = 30;
          break;
        case 27:
          _context7.prev = 27;
          _context7.t0 = _context7["catch"](13);
          console.error(_context7.t0);
          // NOP
        case 30:
        case "end":
          return _context7.stop();
      }
    }, _callee6, null, [[13, 27]]);
  })();
}

/** Root saga for the plugin */
function textSaga() {
  return _regeneratorRuntime().wrap(function textSaga$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _context8.next = 2;
        return (0, _effects.all)([(0, _effects.takeEvery)(_actionTypes["default"].IMPORT_CONFIG, injectTranslations), (0, _effects.takeEvery)(_actionTypes["default"].RECEIVE_ANNOTATION, fetchExternalAnnotationResources), (0, _effects.takeEvery)(_actionTypes["default"].RECEIVE_ANNOTATION, processTextsFromAnnotations), (0, _effects.takeEvery)(_actionTypes["default"].SET_CANVAS, discoverExternalOcr), (0, _effects.takeEvery)(_actionTypes["default"].UPDATE_WINDOW, onConfigChange), (0, _effects.takeEvery)(_actions2.PluginActionTypes.REQUEST_TEXT, fetchAndProcessOcr), (0, _effects.takeEvery)(_actions2.PluginActionTypes.REQUEST_COLORS, fetchColors)]);
      case 2:
      case "end":
        return _context8.stop();
    }
  }, _marked2);
}